import { Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Spacing, SpacingUnit } from 'components/ui';

import s from './NotificationDrawerHeader.module.scss';

type NotificationDrawerHeaderProps = {
  formName?: string;
};

const NotificationDrawerHeader: React.FC<NotificationDrawerHeaderProps> = ({
  formName,
}) => {
  const { t } = useTranslation();

  return (
    <Spacing spacing={SpacingUnit.unit3}>
      <div>
        <Typography.Title level={3}>
          {t('formList.notifications.title')}
        </Typography.Title>
        {formName && (
          <Typography.Text className={s.header__description} type="secondary">
            {formName}
          </Typography.Text>
        )}
      </div>
    </Spacing>
  );
};

export default NotificationDrawerHeader;
